<template>
  <div
    class="container-top mt-5"
    :class="{ 'container-wide': lgAndUp || xlAndUp }"
  >
    <div class="row">
      <div class="col-md-12">
        <div class="text-head font-weight-bold h2 text-black">
          Donor Information
        </div>
        <div><BackRoute /></div>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <div class="d-flex justify-content-end align-items-center">
          <div class="d-flex align-items-center">
            <div class="d-flex align-items-center mr-3">
              <span class="mr-2 text-dak">Data range</span>
              <div class="d-flex align-items-center">
                <el-date-picker
                  v-model="dateRangeValue"
                  type="daterange"
                  unlink-panels
                  range-separator="To"
                  start-placeholder="Start date"
                  end-placeholder="End date"
                  :shortcuts="shortcuts"
                  size="large"
                  class="w-100"
                  @change="setDatePicker"
                />
                <!-- <el-date-picker
                  v-model="selectedYear"
                  type="date"
                  format="MM/DD/YYYY"
                  size="large"
                  placeholder="select Year"
                  class="w-100"
                /> -->
              </div>
            </div>
            <button
              @click="printPage"
              class="btn btn-outline-secondary rounded"
            >
              <el-icon><Printer /></el-icon>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <DonorInfoAnalytics :donorData="donorSummaryData" />
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-md-12 mt-5">
        <div v-if="donorData.length > 0">
          <TableSearch
            :data="filteredDonorData"
            :headers="donorHeaders"
            @showfilter="handleFilter"
            @update:searchText="handleSearchTextUpdate"
            :checkMultipleItem="true"
            :filterItem="true"
            :showPrint="false"
            :printingData="donorData"
            @checkedrow="handleSelectionChange"
            v-loading="loading"
          >
            <template v-slot:date="{ item }">
              <div class="c-pointer">
                {{ date(item.date) }}
              </div>
            </template>
            <template v-slot:name="{ item }">
              <div class="c-pointer">
                <!-- {{ item.person.firstName || "" }}
                {{ item.person.lastName || "" }} -->
                {{ item.contribution ? item.contribution.name : "" }}
              </div>
            </template>
            <template v-slot:amount="{ item }">
              <div class="c-pointer">
                {{
                  item.person &&
                  item.person.tenant &&
                  item.person.tenant.country &&
                  item.person.tenant.country.currencyObject &&
                  item.person.tenant.country.currencyObject
                    ? item.person.tenant.country.currencyObject.symbol
                    : ""
                }}{{ Math.abs(item.amount).toLocaleString() }}.00
              </div>
            </template>
            <template v-slot:paymentChannel="{ item }">
              <div class="c-pointer">
                {{ item.paymentChannel }}
              </div>
            </template>
            <template v-slot:action="{ item }">
              <el-dropdown trigger="click">
                <el-icon>
                  <MoreFilled />
                </el-icon>
                <template #dropdown>
                  <el-dropdown-menu>
                    <el-dropdown-item>
                      <div
                        @click="showConfirmModal(item.id, index)"
                        class="text-color"
                      >
                        Delete
                      </div>
                    </el-dropdown-item>
                  </el-dropdown-menu>
                </template>
              </el-dropdown>
            </template>
          </TableSearch>
        </div>
        <div class="text-danger d-flex justify-content-center" v-else>
          No records found
        </div>

        <div class="d-flex justify-content-end my-3">
          <el-pagination
            v-model:current-page="serverOptions.page"
            v-model:page-size="serverOptions.rowsPerPage"
            background
            layout="total, prev, pager, next, jumper"
            :total="totalDonorCount"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
    <el-dialog
      v-model="showFilter"
      title=""
      :width="mdAndUp || lgAndUp || xlAndUp ? `35%` : xsOnly ? `90%` : `70%`"
      class="QRCodeDialog border-radius-20"
      align-center
    >
      <div class="filter-optio">
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 text-center text-black h2 fw-500">Filter</div>
            <div class="col-md-12 text-center text-black s-24">
              Narrow down your search
            </div>
            <div class="col-md-12 mt-3">
              <div class="row justify-content-center">
                <div class="col-md-11 form-group">
                  <div class="text-black">Offering</div>
                  <el-input
                    placeholder="Offering"
                    class="w-100"
                    v-model="filter.contribution"
                  />
                </div>
                <div class="col-md-11 form-group">
                  <div class="text-black">Donor</div>
                  <el-input
                    placeholder="Donor"
                    class="w-100"
                    v-model="filter.donor"
                  />
                </div>
                <div class="col-md-12 d-flex pb-3 justify-content-center">
                  <el-button
                    class="col-md-11 text-white"
                    :color="primarycolor"
                    @click="applyFilter"
                    :loading="applyLoading"
                    :disabled="disableBtn"
                    round
                    >Apply</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, computed, inject, watch } from "vue";
import BackRoute from "../../../components/backroute/BackRoute.vue";
import deviceBreakpoint from "../../../mixins/deviceBreakpoint";
import moment from "moment";
import DonorInfoAnalytics from "./DonorInfoAnalytics.vue";
import TableSearch from "@/components/table/TableSearch";
import monthDayYear from "../../../services/dates/dateformatter";
import contributionservice from "../../../services/financials/contributionservice";
import printJS from "print-js";
import { useRoute } from "vue-router";
import datePickerShortcut from "@/mixins/el-datepicker-shortcut.vue";

const { mdAndUp, lgAndUp, xlAndUp, xsOnly } = deviceBreakpoint();
const searchText = ref("");
const selectedYear = ref("");
const route = useRoute();
const primarycolor = inject("primarycolor");
const filter = ref({});
const totalDonorCount = ref(100);
const marked = ref([]);
const showFilter = ref(false);
const applyLoading = ref(false);
const dateRangeValue = ref(null);
const loading = ref(false);
const { shortcuts } = ref(datePickerShortcut());
const navigatorLang = ref(navigator.language);
const startDate = ref("");
const endDate = ref("");

const donorHeaders = ref([
  { name: "Date", value: "date" },
  { name: "Donation", value: "name" },
  { name: "Amount", value: "amount" },
  { name: "Channel", value: "paymentChannel" },
  { name: "Action", value: "action" },
]);
const donorData = ref([]);
const donorSummaryData = ref({});

const handleSizeChange = (val) => {
  console.log(`${val} items per page`);
};
const handleCurrentChange = (val) => {
  console.log(`current page: ${val}`);
};
const totalDonorAmount = computed(() => {
  return donorData.value.reduce((sum, record) => sum + record.amount, 0);
});
const setDatePicker = () => {
  startDate.value = dateRangeValue.value[0];
  endDate.value = dateRangeValue.value[1];
};
const headerIcon = require("@/assets/printheadericon.png");
const churchPlusLogo = require("@/assets/churchplusblueLogo.png");
const printPage = () => {
  const htmlContent = `
   <div class="row">
    <img
      src="${headerIcon}"
      alt="header"
      style="max-width: 100%; max-height: 100%; margin-bottom: 20px;"
    />
    </div>
    <div class="text-dak text-font">

      <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <img
            src="${donorSummaryData.value.person?.tenant?.logo || ""}"
            alt="Logo"
            style="max-width: 90px; max-height: 60px;"
          />
          <div class="text-muted s-13" style="margin-left: 9px; font-weight: 600">
            ${donorSummaryData.value.person?.tenant?.name || ""}
          </div>
        </div>
        <div class="">
          <div class="text-muted s-13 mb-1">Name</div>
          <div class="s-20 font-weight-600 text-black mb-2">
            ${donorSummaryData.value.person?.firstName || ""}
            ${donorSummaryData.value.person?.lastName || ""}
          </div>

          <div class="mb-2">
            <div class="text-muted s-13">Email Address</div>
            <div class="text-black">
              ${donorSummaryData.value.person?.email || ""}
            </div>
          </div>
          <div class="mb-2">
            <div class="text-muted s-13">Phone Number</div>
            <div class="text-black">
              ${donorSummaryData.value.person?.mobilePhone || ""}
            </div>
          </div>
        </div>
      </div>

      <h3 style="text-align:left;">Giving Summary</h3>
      <table style="width:100%;">
        <thead class="table-head text-left">
          <tr>
            <th style=" padding:8px 12px;">Donation</th>
            <th style=" padding:8px 12px;">Date</th>
            <th style=" padding:8px 12px;">Amount</th>
            <th style=" padding:8px 12px;">Channel</th>
          </tr>
        </thead>
      <tbody>
          ${donorData.value
            .map(
              (d) => `
            <tr>
              <td style="border-bottom:1px solid #ddd; padding:8px;">${
                d.contribution ? d.contribution.name : ""
              }</td>
              <td style="border-bottom:1px solid #ddd; padding:8px;">${moment(
                d.date
              ).format("MMM DD, YYYY")}</td>
              <td style="border-bottom:1px solid #ddd; padding:8px;">${
                d.person &&
                d.person.tenant &&
                d.person.tenant.country &&
                d.person.tenant.country.currencyObject &&
                d.person.tenant.country.currencyObject
                  ? d.person.tenant.country.currencyObject.symbol
                  : ""
              }${d.amount.toLocaleString()}</td>
              <td style="border-bottom:1px solid #ddd; padding:8px;">${
                d.paymentChannel
              }</td>
            </tr>
          `
            )
            .join("")}
        </tbody>
      <tbody>

            <tr>
              <td>Total</td>
              <td></td>
              <td></td>
              <td class="font-weight-600" >${
                donorSummaryData.value.person &&
                donorSummaryData.value.person.tenant &&
                donorSummaryData.value.person.tenant.country &&
                donorSummaryData.value.person.tenant.country.currencyObject &&
                donorSummaryData.value.person.tenant.country.currencyObject
                  ? donorSummaryData.value.person.tenant.country.currencyObject
                      .symbol
                  : ""
              } ${totalDonorAmount.value.toLocaleString()}</td>
            </tr>

        </tbody>
      </table>
       <div class="row justify-content-center align-items-center" style="margin-top: 30px">
        <div>Powered by</div>
          <img
          class="mt-4"
           src="${churchPlusLogo}"
            alt="ChurchPlus"
            style="max-width: 70px; max-height: 70px; margin-bottom: 20px;"
          />
    </div>
    </div>
  `;

  printJS({
    printable: htmlContent,
    type: "raw-html",
    style: `
    @media (max-width: 600px) {
      .flex-column { flex-direction: column; align-items: flex-start; }
    }
    .text-font { font-family: poppins, sans-serif; }
    .justify-content-between { justify-content: space-between; }
    .col-md-5 { flex: 0 0 auto; width: 41.666667%; }
      .col-md-7 { flex: 0 0 auto; width: 58.333333%; }
      .border-radius-20 { border-radius: 20px; }
      .c-pointer { cursor: pointer; }
    .flex-sm-row { display: flex; flex-direction: row; }
      .text-black { color: #000000; }
      .text-secondary { color: #6c757d; }
      .table-head {background: #f4f4f4ab !important;}
      .table-head th {
        font-weight: 600;
        font-size: 15px;
        text-transform: lowercase;
        margin: 0;
        color: #000000;

      }
        .text-left{ text-align: left; }
         table tbody tr {
            padding-bottom: 5px;
            padding-top: 5px;
          }

          table td {
            padding: 7px 10px;
          }

          table tbody tr td:nth-child(even) {
            background: #f1f5f8;
          }
        .table-head th::first-letter {
          text-transform: capitalize;
        }
      .text-color { color: ${primarycolor}; }
      table thead tr {
          border-bottom: 1px solid #d4dde3 !important;
        }
        table tbody tr:hover {
          background-color: #fafafa !important;
        }
      .mb-1 { margin-bottom: 0.25rem; }
      .mb-2 { margin-bottom: 0.5rem; }
      .mb-3 { margin-bottom: 1rem; }
      .mb-4 { margin-bottom: 1.5rem; }
      .mt-5 { margin-top: 3rem; }
      .mt-4 { margin-top: 1.5rem; }
      .mr-2 { margin-right: 0.5rem; }
      .mr-3 { margin-right: 1rem; }
      .w-100 { width: 100%; }
      .d-flex { display: flex; }
      .align-items-center { align-items: center; }
      .align-items-end { align-items: end; }
      .justify-content-end { justify-content: end; }
      .justify-content-center { justify-content: center; }
      .container-top { padding: 15px; }
      .container-wide { max-width: 1200px; margin: auto; }
    .row { display: flex; flex-wrap: wrap; margin-right: -15px; margin-left: -15px; }
      .text-head { font-size: 24px; font-weight: bold; margin-bottom: 20px; }
      .text-dak { color: #000000; }
      .text-muted { color: #6c757d; }
      .s-13 { font-size: 13px; }
      .s-20 { font-size: 20px; }
      .font-weight-600 { font-weight: 600; }
  `,
  });
};

const date = (offDate) => {
  return monthDayYear.monthDayYear(offDate);
};

const getSingleDonation = async () => {
  loading.value = true;
  // const today = moment().format("YYYY-MM-DD");

  // default to empty string
  // let startDate = "";

  if (startDate.value && endDate.value) {
    startDate.value = new Date(startDate.value).toLocaleDateString("en-US");
    endDate.value = new Date(endDate.value).toLocaleDateString("en-US");
  }

  try {
    const response = await contributionservice.getDonationSummaryPerPerson(
      route.query.id,
      startDate.value,
      endDate.value
    );

    if (response) {
      console.log(response, "single donation response");
      donorData.value = response.contributions;
      donorSummaryData.value = response;
    }
  } catch (error) {
    console.error("Error fetching contribution details:", error);
    throw error;
  } finally {
    loading.value = false;
  }
};

getSingleDonation();

watch(endDate && startDate, () => {
  getSingleDonation();
});

const serverOptions = ref({
  page: 1,
  rowsPerPage: 50,
});
watch(
  serverOptions.value,
  () => {
    getPeopleByPage();
  },
  { deep: true }
);
const handleFilter = (newValue) => {
  showFilter.value = newValue;
};
const handleSearchTextUpdate = (newValue) => {
  searchText.value = newValue;
};
const handleSelectionChange = (val) => {
  marked.value = val;
};
const disableBtn = computed(() => {
  if (!filter.value.contribution && !filter.value.donor) return true;
  return false;
});
const filteredDonorData = computed(() => {
  if (!searchText.value) return donorData.value;
  return donorData.value.filter((d) =>
    Object.values(d).some((val) =>
      String(val).toLowerCase().includes(searchText.value.toLowerCase())
    )
  );
});
const applyFilter = () => {
  applyLoading.value = true;
  setTimeout(() => {
    applyLoading.value = false;
    showFilter.value = false;
  }, 1000);
};
</script>
